export default "__VITE_ASSET__BUQmgDTt__"